import React from 'react';

function OrderStoreSummary() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="url(#paint0_linear_1822_34494)" />
      <rect x="5" y="24" width="22" height="0.8" rx="0.25" fill="#D6E2F6" />
      <path
        d="M7.63184 24.0003H10.8953V17.4734H14.1587V24.0003H23.9491V14.2099H7.63184C7.63184 14.2099 7.63184 24.0003 7.63184 24.0003Z"
        fill="#E3E5E5"
      />
      <path d="M7.63184 14.2099V15.8417L15.7905 24.0003H23.9491V14.2099H7.63184Z" fill="#BFBFBF" />
      <rect x="9.26367" y="17.4728" width="4.89518" height="6.52691" fill="#A5A3A3" />
      <path d="M9.26367 17.4734L14.1589 22.3686V17.4734H9.26367Z" fill="#8A8A8A" />
      <rect x="15.791" y="17.4728" width="6.52691" height="4.89518" fill="#A5A3A3" />
      <rect x="7.63184" y="6.05069" width="16.3173" height="1.63173" fill="#D84234" />
      <path d="M10.8952 8.4989H7.63173L6 14.2099H9.91615L10.8952 8.4989Z" fill="#D84234" />
      <path d="M14.1585 8.4989H10.8951L9.91602 14.2099H13.8322L14.1585 8.4989Z" fill="white" />
      <path d="M17.4218 8.4989H14.1584L13.832 14.2099H17.7482L17.4218 8.4989Z" fill="#D84234" />
      <path d="M20.6853 8.4989H17.4219L17.7482 14.2099H21.6644L20.6853 8.4989Z" fill="white" />
      <path d="M23.949 8.4989H20.6855L21.6646 14.2099H25.5807L23.949 8.4989Z" fill="#D84234" />
      <path
        d="M9.91615 15.0258C9.91615 16.0864 9.0187 16.9839 7.95807 16.9839C6.89745 16.9839 6 16.0864 6 15.0258V14.2099H9.91615V15.0258Z"
        fill="#AE362B"
      />
      <path
        d="M17.7482 15.0258C17.7482 16.0864 16.8507 16.9839 15.7901 16.9839C14.7295 16.9839 13.832 16.0864 13.832 15.0258V14.2099H17.7482V15.0258Z"
        fill="#AE362B"
      />
      <path
        d="M25.5812 15.0258C25.5812 16.0864 24.6837 16.9839 23.6231 16.9839C22.5625 16.9839 21.665 16.0864 21.665 15.0258V14.2099H25.5812V15.0258Z"
        fill="#AE362B"
      />
      <path
        d="M13.8322 15.0258C13.8322 16.0864 12.9347 16.9839 11.8741 16.9839C10.8135 16.9839 9.91602 16.0864 9.91602 15.0258V14.2099H13.8322V15.0258Z"
        fill="#CDCCCC"
      />
      <path
        d="M21.6642 15.0258C21.6642 16.0864 20.7667 16.9839 19.7061 16.9839C18.6455 16.9839 17.748 16.0864 17.748 15.0258V14.2099H21.6642V15.0258Z"
        fill="#CDCCCC"
      />
      <rect x="7.63184" y="7.68242" width="16.3173" height="0.815864" fill="white" />
      <path
        d="M15.79 17.4734V19.1051L19.0535 22.3686H22.317L20.6852 20.7369L17.4218 17.4734H15.79Z"
        fill="#8A8A8A"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1822_34494"
          x1="32"
          y1="28.821"
          x2="32"
          y2="-3.17901"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F1F6FF" />
          <stop offset="1" stop-color="#EBF2FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default OrderStoreSummary;
